var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src !== 'under_construction')?_c('div',{staticClass:"tw-hidden sm:tw-flex"},[_c('iframe',{attrs:{"height":"100%","width":"100%","src":_vm.src}})]):_c('div',{staticClass:"tw-hidden sm:tw-flex tw-flex tw-justify-center tw-items-center tw-text-xl",staticStyle:{"background-color":"lightgrey"}},[_vm._v("\n    Website Under Construction\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }